import { Component } from '@angular/core';

import { AppTabPageData } from '../core/models/tab-page-data.model';
import { DomainConfigurationsFormComponent } from '../layout/components/topbar/domain-configurations/domain-configurations-form/domain-configurations-form.component';
import { LandingPageListComponent } from '../pages/content-management/landing-page-list/landing-page-list.component';
import { LandingPageFormComponent } from '../pages/content-management/landing-page/landing-page.component';
import { DescendantShortLinksComponent } from '../pages/content-management/short-links/descendant-short-links/descendant-short-links.component';
import { ShortLinksComponent } from '../pages/content-management/short-links/short-links.component';
import { FrontAuditsComponent } from '../pages/dashboard/front-audits/front-audits.component';
import { CalendarEventComponent } from '../pages/facility/calendar-event/calendar-event.component';
import { ContactsByCellPhoneComponent } from '../pages/facility/contacts/contacts-by-cellphone/contacts-by-cellphone.component';
import { CustomerClubDevicesComponent } from '../pages/facility/customer-club-devices/customer-club-devices.component';
import { DynamicTemplatesComponent } from '../pages/facility/dynamic-templates/dynamic-templates.component';
import { InformationUsersSeenComponent } from '../pages/facility/information-users-seen/information-users-seen.component';
import { InformationsComponent } from '../pages/facility/informations/informations.component';
import { PanelDocumentationsComponent } from '../pages/facility/panel-documentations/panel-documentations.component';
import { PhonebookComponent } from '../pages/facility/phonebook/phonebook.component';
import { SmsTemplateGroupComponent } from '../pages/facility/sms-template-group/sms-template-group.component';
import { SmsTemplateComponent } from '../pages/facility/sms-template/sms-template.component';
import { AccountInformationComponent } from '../pages/financial/account-information/account-information.component';
import { ChequePaymentsComponent } from '../pages/financial/cheque-payments/cheque-payment/cheque-payments.component';
import { ResellerChequePaymentsComponent } from '../pages/financial/cheque-payments/reseller-cheque-payment/reseller-cheque-payments.component';
import { DiscountComponent } from '../pages/financial/discount/discount.component';
import { NewPaymentComponent } from '../pages/financial/new-payment/new-payment.component';
import { PaymentsForConfirmComponent } from '../pages/financial/payments-for-confirm/payment-for-confirm/payments-for-confirm.component';
import { ResellerPaymentsForConfirmComponent } from '../pages/financial/payments-for-confirm/reseller-payment-for-confirm/reseller-payments-for-confirm.component';
import { PaymentsComponent } from '../pages/financial/payments/payment/payments.component';
import { ResellerPaymentsComponent } from '../pages/financial/payments/reseller-payment/reseller-payments.component';
import { AggregatorsComponent } from '../pages/infrastructure/aggregators/aggregators.component';
import { NumbersAggregatorFormComponent } from '../pages/infrastructure/aggregators/numbers-aggregator-form/numbers-aggregator-form.component';
import { NumbersBlackListsFormComponent } from '../pages/infrastructure/aggregators/numbers-black-lists-form/numbers-black-lists-form.component';
import { allPrivateNumberSendLimitComponent } from '../pages/infrastructure/all-private-number-send-limit/all-private-number-send-limit.component';
import { ApiAuditsComponent } from '../pages/infrastructure/api-audits/api-audits.component';
import { BlackListComponent } from '../pages/infrastructure/black-list/black-list.component';
import { BulkNumberInformationComponent } from '../pages/infrastructure/bulk-number-information/bulk-number-information.component';
import { BulkNumberInformation2Component } from '../pages/infrastructure/bulk-number-information2/bulk-number-information2.component';
import { DocumentsManagementComponent } from '../pages/infrastructure/documents-management/documents-management.component';
import { KibanaDashboardsComponent } from '../pages/infrastructure/kibana-dashboards/kibana-dashboards.component';
import { MenusComponent } from '../pages/infrastructure/menus/menus.component';
import { GetQueuesStatisticsComponent } from '../pages/infrastructure/queues-statistics/get-queues-statistics/get-queues-statistics.component';
import { RefundDeliveryStatusComponent } from '../pages/infrastructure/refund-delivery-status/refund-delivery-status.component';
import { RuleAuditsComponent } from '../pages/infrastructure/rule-audits/rule-audits.component';
import { SettingComponent } from '../pages/infrastructure/setting/setting.component';
import { SmsSenderAgentsComponent } from '../pages/infrastructure/sms-sender-agents/sms-sender-agents.component';
import { SuperAdminAuditsComponent } from '../pages/infrastructure/super-admin-audits/super-admin-audits.component';
import { SystemNumbersComponent } from '../pages/infrastructure/system-numbers/system-numbers.component';
import { ZonePostalCodesComponent } from '../pages/infrastructure/zone-postal-codes/zone-postal-codes.component';
import { ZonesComponent } from '../pages/infrastructure/zones/zones.component';
import { MediasComponent } from '../pages/medias/medias/medias.component';
import { ChildrenOrganizationsPackagesComponent } from '../pages/package-organization/package-organizations/children-organizations-packages/children-organizations-packages.component';
import { OrganizationPackagesComponent } from '../pages/package-organization/package-organizations/organization-packages/organization-packages.component';
import { PackageOrganizationsComponent } from '../pages/package-organization/package-organizations/package-organizations.component';
import { PackageSalesComponent } from '../pages/package-organization/package-sales/package-sales.component';
import { PlansManagementComponent } from '../pages/plans/plans-management/plans-management.component';
import { GetPlansTypeModuleComponent } from '../pages/plans/plans-type-module/get-plans-type-module/get-plans-type-module.component';
import { GetPlansTypePackageComponent } from '../pages/plans/plans-type-package/get-plans-type-package/get-plans-type-package.component';
import { ChildrenPrivateNumberBuyRequestsComponent } from '../pages/private-number-price/children-private-number-buy-requests/children-private-number-buy-requests.component';
import { PrivateNumberBuyRequestsComponent } from '../pages/private-number-price/private-number-buy-requests/private-number-buy-requests.component';
import { PrivateNumbersPriceForUserComponent } from '../pages/private-number-price/private-numbers-price-for-user/private-numbers-price-for-user.component';
import { PrivateNumbersPriceComponent } from '../pages/private-number-price/private-numbers-price/private-numbers-price.component';
import { ExcelRequestComponent } from '../pages/requests/excel-request/excel-request.component';
import { PhonebookFileProgressesComponent } from '../pages/requests/phonebook-file-progresses/phonebook-file-progresses.component';
import { CampaignsComponent } from '../pages/sending-system/campaigns/campaigns.component';
import { FastSendSmsPatternByPhonebookComponent } from '../pages/sending-system/fast-send-sms-pattern-by-phonebook/fast-send-sms-pattern-by-phonebook.component';
import { SendBalkSmsComponent } from '../pages/sending-system/send-balk-sms/send-balk-sms.component';
import { SendBalkSms2Component } from '../pages/sending-system/send-balk-sms2/send-balk-sms2.component';
import { SendOccasionSmsComponent } from '../pages/sending-system/send-occasion-sms/send-occasion-sms.component';
import { SendP2pSmsComponent } from '../pages/sending-system/send-p2p-sms/send-p2p-sms.component';
import { SendP2pTrackingNumberSmsComponent } from '../pages/sending-system/send-p2p-tracking-number-sms/send-p2p-tracking-number-sms.component';
import { SendSmsFromMapComponent } from '../pages/sending-system/send-sms-from-map/send-sms-from-map.component';
import { SendSmsFromMap2Component } from '../pages/sending-system/send-sms-from-map2/send-sms-from-map2.component';
import { SendSmsWithPhonebookComponent } from '../pages/sending-system/send-sms-with-phonebook/send-sms-with-phonebook.component';
import { SendZonePostalCodeSmsComponent } from '../pages/sending-system/send-zone-postal-code-sms/send-zone-postal-code-sms.component';
import { AllIpRulesComponent } from '../pages/setting/api-token/all-ip-rules/all-ip-rules.component';
import { ApiTokenComponent } from '../pages/setting/api-token/api-token.component';
import { CreditNotificationComponent } from '../pages/setting/credit-notification/credit-notification.component';
import { OtpComponent } from '../pages/setting/otp/otp.component';
import { WebHookComponent } from '../pages/setting/web-hook/web-hook.component';
import { CustomPlaceComponent } from '../pages/smart-sms/custom-place/custom-place.component';
import { SendP2pSmartSmsComponent } from '../pages/smart-sms/p2p-smart-sms/p2p-smart-sms.component';
import { ResellerSmartSmsRequestComponent } from '../pages/smart-sms/reseller-smart-sms-request/reseller-smart-sms-request.component';
import { SendSmartSmsConfirmPage } from '../pages/smart-sms/send-smart-sms-confirm-request/send-smart-sms-confirm-request.component';
import { SendSmartSmsCreateRequestComponent } from '../pages/smart-sms/send-smart-sms-create-request/send-smart-sms-create-request.component';
import { SendSmartDetailsByDeliveryComponent } from '../pages/smart-sms/send-smart-sms-request/send-details-by-delivery/send-smart-sms-details-by-delivery.component';
import { SendSmartDetailsComponent } from '../pages/smart-sms/send-smart-sms-request/send-details/send-smart-sms-details.component';
import { SendSmartSmsRequestListComponent } from '../pages/smart-sms/send-smart-sms-request/send-smart-sms-request-list.component';
import { SendSmartSmsToResidentsComponent } from '../pages/smart-sms/send-smart-sms-to-residents/send-smart-sms-to-residents.component';
import { SmartSmsCampaignsComponent } from '../pages/smart-sms/smart-sms-campaigns/smart-sms-campaigns.component';
import { SmartSmsClubsComponent } from '../pages/smart-sms/smart-sms-clubs/smart-sms-clubs.component';
import { InboxGroupsComponent } from '../pages/sms-reports/inbox-groups/inbox-groups.component';
import { OrganizationInboxesComponent } from '../pages/sms-reports/inbox/organization-inbox/organization-inboxes.component';
import { userInboxesComponent } from '../pages/sms-reports/inbox/users-inbox/users-inboxes.component';
import { OccasionScheduledMessageComponent } from '../pages/sms-reports/occasion-scheduled-messages/occasion-scheduled-messages.component';
import { CurrentUserOutboxMessagesComponent } from '../pages/sms-reports/send-outboxes/current-user-outbox-messages/current-user-outbox-messages.component';
import { ResellerOutboxMessagesComponent } from '../pages/sms-reports/send-outboxes/reseller-outbox-messages/reseller-outbox-messages.component';
import { UserOutboxMessagesComponent } from '../pages/sms-reports/send-outboxes/user-outbox-messages/user-outbox-messages.component';
import { UsersOutboxMessagesComponent } from '../pages/sms-reports/send-outboxes/users-outbox-messages/users-outbox-messages.component';
import { CurrentUserSendQueueComponent } from '../pages/sms-reports/send-queues/current-user-send-queue/current-user-send-queue.component';
import { ResellerSendQueueComponent } from '../pages/sms-reports/send-queues/reseller-send-queue/reseller-send-queue.component';
import { UserSendQueueComponent } from '../pages/sms-reports/send-queues/user-send-queue/user-send-queue.component';
import { DynamicSendReceiversComponent } from '../pages/sms-reports/shared/dynamic-send-receivers/dynamic-send-receivers.component';
import { SendReceiversComponent } from '../pages/sms-reports/shared/send-receivers/send-receivers.component';
import { CurrentOrganOperatorAggregateCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/aggregate-compare-statistics/operator-aggregate/current-organ-operator-aggregate/current-organ-operator-aggregate.component';
import { CurrentUserOperatorAggregateCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/aggregate-compare-statistics/operator-aggregate/current-user-operator-aggregate/current-user-operator-aggregate.component';
import { SuperAdminOperatorAggregateCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/aggregate-compare-statistics/operator-aggregate/super-admin-operator-aggregate/super-admin-operator-aggregate.component';
import { CurrentOrganSentCountAggregateCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/aggregate-compare-statistics/sent-count-aggregate/current-organ-sent-count-aggregate/current-organ-sent-count-aggregate.component';
import { CurrentUserSentCountAggregateCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/aggregate-compare-statistics/sent-count-aggregate/current-user-sent-count-aggregate/current-user-sent-count-aggregate.component';
import { SuperAdminSentCountAggregateCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/aggregate-compare-statistics/sent-count-aggregate/super-admin-sent-count-aggregate/super-admin-sent-count-aggregate.component';
import { CurrentOrganSentStatusAggregateCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/aggregate-compare-statistics/sent-status-aggregate/current-organ-sent-status-aggregate/current-organ-sent-status-aggregate.component';
import { CurrentUserSentStatusAggregateCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/aggregate-compare-statistics/sent-status-aggregate/current-user-sent-status-aggregate/current-user-sent-status-aggregate.component';
import { SuperAdminSentStatusAggregateCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/aggregate-compare-statistics/sent-status-aggregate/super-admin-sent-status-aggregate/super-admin-sent-status-aggregate.component';
import { CurrentOrganOperatorSeasonsCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/seasons-compare-statistics/operator-seasons-compare-statistics/current-organ-operator-seasons/current-organ-operator-seasons.component';
import { CurrentUserOperatorSeasonsCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/seasons-compare-statistics/operator-seasons-compare-statistics/current-user-operator-seasons/current-user-operator-seasons.component';
import { SuperAdminOperatorSeasonsCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/seasons-compare-statistics/operator-seasons-compare-statistics/super-admin-operator-seasons/super-admin-operator-seasons.component';
import { CurrentOrganSentCountSeasonsCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/seasons-compare-statistics/sent-count-seasons-compare-statistics/current-organ-sent-count-seasons/current-organ-sent-count-seasons.component';
import { CurrentUserSentCountSeasonsCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/seasons-compare-statistics/sent-count-seasons-compare-statistics/current-user-sent-count-seasons/current-user-sent-count-seasons.component';
import { SuperAdminSentCountSeasonsCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/seasons-compare-statistics/sent-count-seasons-compare-statistics/super-admin-sent-count-seasons/super-admin-sent-count-seasons.component';
import { CurrentOrganSentStatusSeasonsCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/seasons-compare-statistics/sent-status-seasons-compare-statistics/current-organ-sent-status-seasons/current-organ-sent-status-seasons.component';
import { CurrentUserSentStatusSeasonsCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/seasons-compare-statistics/sent-status-seasons-compare-statistics/current-user-sent-status-seasons/current-user-sent-status-seasons.component';
import { SuperAdminSentStatusSeasonsCompareStatisticsComponent } from '../pages/statistical-reports/compare-statistics/seasons-compare-statistics/sent-status-seasons-compare-statistics/super-admin-sent-status-seasons/super-admin-sent-status-seasons.component';
import { ComplexStatisticsComponent } from '../pages/statistical-reports/complex-statistics/complex-statistics/complex-statistics.component';
import { CurrentOrganizationResellersStatisticsComponent } from '../pages/statistical-reports/current-organization-resellers-statistics/current-organization-resellers-statistics/current-organization-resellers-statistics.component';
import { OperatorsTodayStatisticsComponent } from '../pages/statistical-reports/operators-today-statistics/operators-today-statistics/operators-today-statistics.component';
import { CurrentOrganizationSentCountStatisticsComponent } from '../pages/statistical-reports/sent-count-statistics/current-organization-sent-count-statistics/current-organization-sent-count-statistics.component';
import { CurrentUserSentCountStatisticsComponent } from '../pages/statistical-reports/sent-count-statistics/current-user-sent-count-statistics/current-user-sent-count-statistics.component';
import { SendCountStatisticsComponent } from '../pages/statistical-reports/sent-count-statistics/send-count-statistics/send-count-statistics.component';
import { CurrentOrganizationSendStatusStatisticsComponent } from '../pages/statistical-reports/sent-status-statistics/current-organization-send-status-statistics/current-organization-send-status-statistics.component';
import { CurrentUserSendStatusStatisticsComponent } from '../pages/statistical-reports/sent-status-statistics/current-user-send-status-statistics/current-user-send-status-statistics.component';
import { SendStatusStatisticsComponent } from '../pages/statistical-reports/sent-status-statistics/send-status-statistics/send-status-statistics.component';
import { CurrentOrganizationStatisticsByPartLengthComponent } from '../pages/statistical-reports/statistics-by-part-length/current-organization-statistics-by-part-length/current-organization-statistics-by-part-length.component';
import { CurrentUserStatisticsByPartLengthComponent } from '../pages/statistical-reports/statistics-by-part-length/current-user-statistics-by-part-length/current-user-statistics-by-part-length.component';
import { StatisticsByPartLengthComponent } from '../pages/statistical-reports/statistics-by-part-length/statistics-by-part-length/statistics-by-part-length.component';
import { CurrentUserTodayStatisticsComponent } from '../pages/statistical-reports/today-statistics/current-user-today-statistics/current-user-today-statistics.component';
import { TodayStatisticsByUserIdComponent } from '../pages/statistical-reports/today-statistics/today-statistics/today-statistics.component';
import { PrivateNumberSendLimitComponent } from '../pages/system-management/assign-numbers/private-number-send-limit/private-number-send-limit.component';
import { PrivateReceiveKeywordsComponent } from '../pages/system-management/assign-numbers/private-receive-keywords/private-receive-keywords.component';
import { AutomaticResendComponent } from '../pages/system-management/automatic-resend/automatic-resend.component';
import { GroupPriceCategoriesComponent } from '../pages/system-management/group-price/group-price-categories.component';
import { MyGroupPriceDetailsComponent } from '../pages/system-management/group-price/my-group-price-details/my-group-price-details.component';
import { OrganizationCustomFieldsComponent } from '../pages/system-management/organization-custom-fields/organization-custom-fields.component';
import { OrganizationsComponent } from '../pages/system-management/organizations/organizations.component';
import { ResellerOrganizationTransactionsComponent } from '../pages/system-management/reseller-organization-transactions/reseller-organization-transactions.component';
import { ResellerOrganizationComponent } from '../pages/system-management/reseller-organization/reseller-organization.component';
import { ResellersTargetComponent } from '../pages/system-management/resellers-target/resellers-target.component';
import { ResellerOrganizationsComponent } from '../pages/system-management/resellers/reseller-organizations/reseller-organizations.component';
import { ResellersComponent } from '../pages/system-management/resellers/resellers.component';
import { RolesComponent } from '../pages/system-management/roles/roles.component';
import { ConfirmUserSafeIpsComponent } from '../pages/system-management/safe-ips/confirm-user-safe-ips/confirm-user-safe-ips.component';
import { SafeIpsComponent } from '../pages/system-management/safe-ips/safe-ips/safe-ips.component';
import { SendLimitsComponent } from '../pages/system-management/send-limits/send-limits.component';
import { TransferPrivateNumbersComponent } from '../pages/system-management/transfer-private-numbers/transfer-private-numbers.component';
import { ActiveSessionsComponent } from '../pages/system-management/users/active-sessions/active-sessions.component';
import { ResellerUsersComponent } from '../pages/system-management/users/reseller-users/reseller-users.component';
import { UserInfoComponent } from '../pages/system-management/users/user-info/user-info.component';
import { UserPersonalInfoComponent } from '../pages/system-management/users/user-personal-info/user-personal-info.component';
// import { UserPointsComponent } from '../pages/system-management/users/user-points/user-points.component';
import { CheckNumberClassResponsesComponent } from '../pages/filimo-smart/check-number-class-responses/check-number-class-responses.component';
import { SmartSmsNumberClassesComponent } from '../pages/filimo-smart/smart-sms-number-classes/smart-sms-number-classes.component';
import { OnlineSurveyListComponent } from '../pages/online-surveys/online-survey-list/online-survey-list.component';
import { OnlineSurveyResponsesComponent } from '../pages/online-surveys/online-survey-responses/online-survey-responses.component';
import { OnlineSurveyStatisticsComponent } from '../pages/online-surveys/online-survey-statistics/online-survey-statistics.component';
import { UsersComponent } from '../pages/system-management/users/users.component';
import { ValueOfPurchasePointsComponent } from '../pages/system-management/users/value-of-purchase-points/value-of-purchase-points.component';
import { ValueOfPurchasesComponent } from '../pages/system-management/users/value-of-purchases/value-of-purchases.component';
import { VoiceMessagesGroupComponent } from '../pages/voice-messages/voice-messages-group/voice-messages-group.component';
import { FieldsManagementComponent } from '../pages/white-messages/fields-management/fields-management.component';
import { FormsManagementComponent } from '../pages/white-messages/forms-management/forms-management.component';
import { SendWhiteMessageComponent } from '../pages/white-messages/send-white-message/send-white-message.component';
import { CompetitionParserComponent } from './../pages/app-services/parser/competition-parser/competition-parser.component';
import { SurveyParserComponent } from './../pages/app-services/parser/survey-parser/survey-parser.component';
import { TextParserComponent } from './../pages/app-services/parser/text-parser/text-parser.component';
import { BankOnlineGatewaysComponent } from './../pages/financial/bank-online-gateways/bank-online-gateways.component';
import { CustomerDomainsComponent } from './../pages/infrastructure/customer-domains/customer-domains.component';
import { GuildsComponent } from './../pages/infrastructure/guilds/guilds.component';
import { PrivateNumbersComponent } from './../pages/infrastructure/private-numbers/private-numbers.component';
import { SystemSettingComponent } from './../pages/infrastructure/system-setting/system-setting.component';
import { DynamicSendSmsComponent } from './../pages/sending-system/dynamic-send-sms/dynamic-send-sms.component';
import { SendSmsComponent } from './../pages/sending-system/send-sms/send-sms.component';
import { UsersSendQueueComponent } from './../pages/sms-reports/send-queues/users-send-queue/users-send-queue.component';
import { OutboxTransactionsComponent } from './../pages/sms-reports/shared/outbox-transactions/outbox-transactions.component';
import { CurrentOrganizationComplexStatisticsComponent } from './../pages/statistical-reports/complex-statistics/current-organization-complex-statistics/current-organization-complex-statistics.component';
import { CurrentUserComplexStatisticsComponent } from './../pages/statistical-reports/complex-statistics/current-user-complex-statistics/current-user-complex-statistics.component';
import { CurrentOrganizationOperatorStatisticsComponent } from './../pages/statistical-reports/operator-statistics/current-organization-operator-statistics/current-organization-operator-statistics.component';
import { CurrentUserOperatorStatisticsComponent } from './../pages/statistical-reports/operator-statistics/current-user-operator-statistics/current-user-operator-statistics.component';
import { OperatorStatisticsComponent } from './../pages/statistical-reports/operator-statistics/operator-statistics/operator-statistics.component';
import { CurrentOrganizationTodayStatisticsComponent } from './../pages/statistical-reports/today-statistics/current-organization-today-statistics/current-organization-today-statistics.component';
import { PublicReceiveKeywordsComponent } from './../pages/system-management/assign-numbers/public-receive-keywords/public-receive-keywords.component';
import { FilterWordsComponent } from './../pages/system-management/filter-words/filter-words.component';
import { OrganizationTransactionsComponent } from './../pages/system-management/organization-transactions/organization-transactions.component';
import { UserImpersonatedComponent } from './../pages/system-management/users/user-impersonated/user-impersonated.component';
import { UserLoginsComponent } from './../pages/system-management/users/user-logins/user-logins.component';
import { UserPasswordHistoryComponent } from './../pages/system-management/users/user-password-history/user-password-history.component';
import { VoiceMessagesComponent } from './../pages/voice-messages/voice-messages/voice-messages.component';
import { OrganizationWhiteMessagesComponent } from './../pages/white-messages/organization-white-messages/organization-white-messages.component';
import { WhiteMessagesComponent } from './../pages/white-messages/white-messages/white-messages.component';
import { PageNames } from './page-names.enum';
import { CreateSmsInformationFormComponent } from '../pages/facility/informations/create-sms-information-form/create-sms-information-form.component';
import { ProcessTextResultsComponent } from '../pages/sms-reports/process-text-results/process-text-results.component';

let _PageListConfig: AppTabPageData[] = [
  {
    name: PageNames.privateNumbers,
    component: <Component>PrivateNumbersComponent,
  },
  {
    name: PageNames.systemNumbers,
    component: <Component>SystemNumbersComponent,
  },
  {
    name: PageNames.allPrivateNumberSendLimit,
    component: <Component>allPrivateNumberSendLimitComponent,
  },
  {
    name: PageNames.smsSenderAgents,
    component: <Component>SmsSenderAgentsComponent,
  },
  {
    name: PageNames.customerDomains,
    component: <Component>CustomerDomainsComponent,
  },
  {
    name: PageNames.blackList,
    component: <Component>BlackListComponent,
  },
  {
    name: PageNames.menus,
    component: <Component>MenusComponent,
  },
  {
    name: PageNames.bulkNumberInformation,
    component: <Component>BulkNumberInformationComponent,
  },
  {
    name: PageNames.bulkNumberInformation2,
    title: 'pages.bulkNumberInformation.title2',
    component: <Component>BulkNumberInformation2Component,
  },
  {
    name: PageNames.organizations,
    component: <Component>OrganizationsComponent,
  },
  {
    name: PageNames.organizationCustomFields,
    component: <Component>OrganizationCustomFieldsComponent,
  },
  {
    name: PageNames.userPersonalInfo,
    title: 'pages.users.personalInfo.title',
    component: <Component>UserPersonalInfoComponent,
  },
  {
    name: PageNames.userOrganizationalInfo,
    title: 'pages.users.title',
    component: <Component>UsersComponent,
  },
  {
    name: PageNames.activeSessions,
    component: <Component>ActiveSessionsComponent,
  },
  {
    name: PageNames.resellerUsers,
    component: <Component>ResellerUsersComponent,
  },
  {
    name: PageNames.resellerOrganization,
    component: <Component>ResellerOrganizationComponent,
  },
  {
    name: PageNames.userLogins,
    component: <Component>UserLoginsComponent,
  },
  {
    name: PageNames.userPasswordHistory,
    component: <Component>UserPasswordHistoryComponent,
  },
  {
    name: PageNames.userImpersonated,
    component: <Component>UserImpersonatedComponent,
  },
  {
    name: PageNames.valueOfPurchases,
    component: <Component>ValueOfPurchasesComponent,
  },
  // {
  //   name: PageNames.userPoints,
  //   component: <Component>UserPointsComponent,
  // },
  {
    name: PageNames.userValueOfPurchasePoints,
    component: <Component>ValueOfPurchasePointsComponent,
  },
  {
    name: PageNames.userAuthentication,
    title: 'pages.users.userInfo.title',
    component: <Component>UserInfoComponent,
  },
  {
    name: PageNames.groupPrice,
    title: 'pages.groupPrice.groupPriceCategories.title',
    component: <Component>GroupPriceCategoriesComponent,
  },
  {
    name: PageNames.automaticResend,
    component: <Component>AutomaticResendComponent,
  },
  {
    name: PageNames.sendSMS,
    component: <Component>SendSmsComponent,
  },
  {
    name: PageNames.sendSMSFromMap,
    title: 'pages.sendSmsFromMap.title',
    component: <Component>SendSmsFromMapComponent,
  },

  {
    name: PageNames.sendSMSFromMap2,
    title: 'pages.sendSmsFromMap.title2',
    component: <Component>SendSmsFromMap2Component,
  },
  {
    name: PageNames.sendQueue,
    component: <Component>UserSendQueueComponent,
  },
  {
    name: PageNames.currentUserSendQueue,
    title: 'pages.sendQueue.userTitle',
    component: <Component>CurrentUserSendQueueComponent,
  },
  {
    name: PageNames.resellerSendQueue,
    title: 'pages.sendQueue.resellerTitle',
    component: <Component>ResellerSendQueueComponent,
  },
  {
    name: PageNames.usersSendQueue,
    title: 'pages.sendQueue.usersTitle',
    component: <Component>UsersSendQueueComponent,
  },
  {
    name: PageNames.inboxes,
    title: 'pages.inboxes.organizationInboxesTitle',
    component: <Component>OrganizationInboxesComponent,
  },
  {
    name: PageNames.usersInboxes,
    title: 'pages.inboxes.usersInboxesTitle',
    component: <Component>userInboxesComponent,
  },
  {
    name: PageNames.inboxGroups,
    component: <Component>InboxGroupsComponent,
  },
  {
    name: PageNames.occasionScheduledMessage,
    component: <Component>OccasionScheduledMessageComponent,
  },
  {
    name: PageNames.phonebook,
    component: <Component>PhonebookComponent,
  },
  {
    name: PageNames.informationUsersSeen,
    component: <Component>InformationUsersSeenComponent,
  },
  {
    name: PageNames.createSmsInformation,
    component: <Component>CreateSmsInformationFormComponent,
  },
  {
    name: PageNames.phonebookFileProgresses,
    component: <Component>PhonebookFileProgressesComponent,
  },
  {
    name: PageNames.informations,
    component: <Component>InformationsComponent,
  },
  {
    name: PageNames.contactsByCellPhone,
    component: <Component>ContactsByCellPhoneComponent,

    isMainMenu: false,
  },
  {
    name: PageNames.panelDocumentations,
    component: <Component>PanelDocumentationsComponent,
  },
  {
    name: PageNames.smsTemplate,
    component: <Component>SmsTemplateComponent,
  },
  {
    name: PageNames.smsTemplateGroup,
    title: 'pages.smsTemplate.title',
    component: <Component>SmsTemplateGroupComponent,
  },
  {
    name: PageNames.accountInformation,
    component: <Component>AccountInformationComponent,
  },
  {
    name: PageNames.bankOnlineGateways,
    component: <Component>BankOnlineGatewaysComponent,
  },
  {
    name: PageNames.payments,
    component: <Component>PaymentsComponent,
  },
  {
    name: PageNames.resellerPayments,
    title: 'pages.payments.resellerTitle',
    component: <Component>ResellerPaymentsComponent,
  },
  {
    name: PageNames.newPayment,
    component: <Component>NewPaymentComponent,
  },
  {
    name: PageNames.chequePayments,
    component: <Component>ChequePaymentsComponent,
  },
  {
    name: PageNames.resellerChequePayments,
    title: 'pages.chequePayments.resellerTitle',
    component: <Component>ResellerChequePaymentsComponent,
  },
  {
    name: PageNames.zones,
    component: <Component>ZonesComponent,
  },
  {
    name: PageNames.guilds,
    component: <Component>GuildsComponent,
  },
  {
    name: PageNames.kibanaDashboards,
    component: <Component>KibanaDashboardsComponent,
  },
  {
    name: PageNames.systemSetting,
    component: <Component>SystemSettingComponent,
  },
  {
    name: PageNames.panelSetting,
    component: <Component>SettingComponent,
  },
  {
    name: PageNames.resellers,
    component: <Component>ResellersComponent,
  },
  {
    name: PageNames.resellerOrganizations,
    title: 'pages.resellers.resellerOrganizations.title',
    component: <Component>ResellerOrganizationsComponent,
  },
  {
    name: PageNames.resellerTarget,
    title: 'pages.resellersTarget.title',
    component: <Component>ResellersTargetComponent,
  },
  {
    name: PageNames.publicReceiveKeywords,
    title: 'pages.assignNumbers.publicReceiveKeywords.title',
    component: <Component>PublicReceiveKeywordsComponent,
  },
  {
    name: PageNames.privateNumberSendLimit,
    title: 'pages.assignNumbers.privateNumberSendLimit.title',
    component: <Component>PrivateNumberSendLimitComponent,
  },
  {
    name: PageNames.privateReceiveKeywords,
    title: 'pages.assignNumbers.privateReceiveKeywords.title',
    component: <Component>PrivateReceiveKeywordsComponent,
  },
  {
    name: PageNames.transferPrivateNumbers,
    component: <Component>TransferPrivateNumbersComponent,
  },
  {
    name: PageNames.roles,
    component: <Component>RolesComponent,
  },
  {
    name: PageNames.organizationTransactions,
    component: <Component>OrganizationTransactionsComponent,
  },
  {
    name: PageNames.resellerOrganizationTransactions,
    title: 'pages.organizationTransactions.resellerTransactionTitle',
    component: <Component>ResellerOrganizationTransactionsComponent,
  },
  {
    name: PageNames.sendLimits,
    component: <Component>SendLimitsComponent,
  },
  {
    name: PageNames.outboxTransactions,
    title: 'pages.organizationTransactions.title',
    component: <Component>OutboxTransactionsComponent,

    isMainMenu: false,
  },
  {
    name: PageNames.dynamicSendReceivers,
    title: 'pages.sendQueue.receivers.title',
    component: <Component>DynamicSendReceiversComponent,

    isMainMenu: false,
  },
  {
    name: PageNames.sendReceivers,
    title: 'pages.sendQueue.receivers.title',
    component: <Component>SendReceiversComponent,

    isMainMenu: false,
    param: 1,
  },
  {
    name: PageNames.superAdminAudits,
    component: <Component>SuperAdminAuditsComponent,
  },
  {
    name: PageNames.rulesAudits,
    component: <Component>RuleAuditsComponent,
  },
  {
    name: PageNames.apiAudits,
    component: <Component>ApiAuditsComponent,
  },
  {
    name: PageNames.aggregators,
    component: <Component>AggregatorsComponent,
  },
  {
    name: PageNames.webhook,
    component: <Component>WebHookComponent,
  },
  {
    name: PageNames.apiToken,
    component: <Component>ApiTokenComponent,
  },
  {
    name: PageNames.otp,
    component: <Component>OtpComponent,
  },
  {
    name: PageNames.allIpRules,
    title: 'pages.ipRules.title',
    component: <Component>AllIpRulesComponent,
  },
  // {
  //   name: PageNames.ipRules',
  //   component: <Component>IpRulesComponent,
  //
  // },
  // {
  //   name: PageNames.clientRules',
  //   component: <Component>ClientRulesComponent,
  //
  // },
  {
    name: PageNames.creditNotification,
    component: <Component>CreditNotificationComponent,
  },
  // {
  //   name: PageNames.modules',
  //   component: <Component>ModulesComponent,
  //
  // },
  // {
  //   name: PageNames.modulesOrganizations',
  //   component: <Component>ModulesOrganizationsComponent,
  //
  // },
  {
    name: PageNames.paymentsForConfirm,
    component: <Component>PaymentsForConfirmComponent,
  },
  {
    name: PageNames.resellerPaymentsForConfirm,
    title: 'pages.paymentsForConfirm.resellerTitle',
    component: <Component>ResellerPaymentsForConfirmComponent,
  },
  {
    name: PageNames.filterWords,
    component: <Component>FilterWordsComponent,
  },
  {
    name: PageNames.userOutboxMessages,
    title: 'pages.outboxMessages.title',
    component: <Component>UserOutboxMessagesComponent,
  },
  {
    name: PageNames.currentUserOutboxMessages,
    title: 'pages.outboxMessages.userTitle',
    component: <Component>CurrentUserOutboxMessagesComponent,
  },
  {
    name: PageNames.usersOutboxMessages,
    title: 'pages.outboxMessages.usersTitle',
    component: <Component>UsersOutboxMessagesComponent,
  },
  {
    name: PageNames.resellerOutboxMessages,
    title: 'pages.outboxMessages.resellerTitle',
    component: <Component>ResellerOutboxMessagesComponent,
  },
  {
    name: PageNames.sendSMSWithPhonebook,
    component: <Component>SendSmsWithPhonebookComponent,
  },
  {
    name: PageNames.myGroupPriceDetails,
    component: <Component>MyGroupPriceDetailsComponent,

    isMainMenu: false,
  },
  {
    name: PageNames.sendBulkSMS,
    title: 'pages.sendBalkSms.title',
    component: <Component>SendBalkSmsComponent,
  },
  {
    name: PageNames.sendBulkSMS2,
    title: 'pages.sendBalkSms.title2',
    component: <Component>SendBalkSms2Component,
  },
  {
    name: PageNames.dynamicTemplate,
    component: <Component>DynamicTemplatesComponent,
  },
  {
    name: PageNames.dynamicSendSms,
    component: <Component>DynamicSendSmsComponent,
  },
  {
    name: PageNames.sendP2pSms,
    component: <Component>SendP2pSmsComponent,
  },
  {
    name: PageNames.sendP2pTrackingNumberSms,
    title: 'pages.sendP2pSms.trackingNumberTitle',
    component: <Component>SendP2pTrackingNumberSmsComponent,
  },
  {
    name: PageNames.sendOccasionSms,
    component: <Component>SendOccasionSmsComponent,
  },
  {
    name: PageNames.fastSendSmsPatternByPhonebook,
    component: <Component>FastSendSmsPatternByPhonebookComponent,
  },
  {
    name: PageNames.surveyParser,
    title: 'pages.pollParsers.surveyTitle',
    component: <Component>SurveyParserComponent,
  },
  {
    name: PageNames.competitionParser,
    title: 'pages.pollParsers.competitionTitle',
    component: <Component>CompetitionParserComponent,
  },
  {
    name: PageNames.textParsers,
    component: <Component>TextParserComponent,
  },
  {
    name: PageNames.safeIps,
    title: 'pages.safeIps.safeIpsTitle',
    component: <Component>SafeIpsComponent,

    isMainMenu: false,
  },
  {
    name: PageNames.confirmUserSafeIps,
    title: 'pages.safeIps.confirmUserSafeIpsTitle',
    component: <Component>ConfirmUserSafeIpsComponent,
  },
  {
    name: PageNames.whiteMessagesList,
    title: 'pages.whiteMessages.title',
    component: <Component>WhiteMessagesComponent,
  },
  {
    name: PageNames.organizationWhiteMessages,
    component: <Component>OrganizationWhiteMessagesComponent,
  },
  {
    name: PageNames.sendWhiteMessage,
    component: <Component>SendWhiteMessageComponent,
  },
  {
    name: PageNames.currentOrganizationSentCountStatistics,
    component: <Component>CurrentOrganizationSentCountStatisticsComponent,
  },
  {
    name: PageNames.currentUserSentCountStatistics,
    component: <Component>CurrentUserSentCountStatisticsComponent,
  },
  {
    name: PageNames.sentCountStatistics,
    component: <Component>SendCountStatisticsComponent,
  },
  {
    name: PageNames.currentOrganizationSendStatusStatistics,
    component: <Component>CurrentOrganizationSendStatusStatisticsComponent,
  },
  {
    name: PageNames.currentUserSendStatusStatistics,
    component: <Component>CurrentUserSendStatusStatisticsComponent,
  },
  {
    name: PageNames.sendStatusStatistics,
    component: <Component>SendStatusStatisticsComponent,
  },
  {
    name: PageNames.currentOrganizationOperatorStatistics,
    component: <Component>CurrentOrganizationOperatorStatisticsComponent,
  },
  {
    name: PageNames.currentUserOperatorStatistics,
    component: <Component>CurrentUserOperatorStatisticsComponent,
  },
  {
    name: PageNames.operatorStatistics,
    component: <Component>OperatorStatisticsComponent,
  },
  {
    name: PageNames.complexStatistics,
    component: <Component>ComplexStatisticsComponent,
  },
  {
    name: PageNames.currentOrganizationComplexStatistics,
    component: <Component>CurrentOrganizationComplexStatisticsComponent,
  },
  {
    name: PageNames.currentUserComplexStatistics,
    component: <Component>CurrentUserComplexStatisticsComponent,
  },
  {
    name: PageNames.currentUserTodayStatistics,
    component: <Component>CurrentUserTodayStatisticsComponent,
  },
  {
    name: PageNames.currentOrganizationTodayStatistics,
    component: <Component>CurrentOrganizationTodayStatisticsComponent,
  },
  {
    name: PageNames.todayStatistics,
    component: <Component>TodayStatisticsByUserIdComponent,
  },
  {
    name: PageNames.todayStatisticsByOperator,
    title: 'pages.operatorsTodayStatistics.title',
    component: <Component>OperatorsTodayStatisticsComponent,
  },
  {
    name: PageNames.currentOrganizationStatisticsByPartLength,
    component: <Component>CurrentOrganizationStatisticsByPartLengthComponent,
  },
  {
    name: PageNames.currentUserStatisticsByPartLength,
    component: <Component>CurrentUserStatisticsByPartLengthComponent,
  },
  {
    name: PageNames.statisticsByPartLength,
    component: <Component>StatisticsByPartLengthComponent,
  },
  {
    name: PageNames.sentCountAggregateCompareStatistics,
    title: 'pages.currentUserSentCountAggregateCompareStatistics.title',
    component: <Component>(
      CurrentUserSentCountAggregateCompareStatisticsComponent
    ),
  },
  {
    name: PageNames.sentCountSeasonCompareStatistics,
    title: 'pages.currentUserSentCountSeasonsCompareStatistics.title',
    component: <Component>CurrentUserSentCountSeasonsCompareStatisticsComponent,
  },

  {
    name: PageNames.sentStatusAggregateCompareStatistics,
    title: 'pages.currentUserSentStatusAggregateCompareStatistics.title',
    component: <Component>(
      CurrentUserSentStatusAggregateCompareStatisticsComponent
    ),
  },
  {
    name: PageNames.sentStatusSeasonCompareStatistics,
    title: 'pages.currentUserSentStatusSeasonsCompareStatistics.title',
    component: <Component>(
      CurrentUserSentStatusSeasonsCompareStatisticsComponent
    ),
  },

  {
    name: PageNames.currentOrganSentCountAggregateCompareStatistics,
    component: <Component>(
      CurrentOrganSentCountAggregateCompareStatisticsComponent
    ),
  },
  {
    name: PageNames.currentOrganSentCountSeasonCompareStatistics,
    title: 'pages.currentOrganSentCountSeasonsCompareStatistics.title',
    component: <Component>(
      CurrentOrganSentCountSeasonsCompareStatisticsComponent
    ),
  },

  {
    name: PageNames.superAdminSentCountAggregateCompareStatistics,
    title: 'pages.superAdminSentCountAggregateCompareStatistics.title',
    component: <Component>(
      SuperAdminSentCountAggregateCompareStatisticsComponent
    ),
  },
  {
    name: PageNames.superAdminSentCountSeasonCompareStatistics,
    title: 'pages.superAdminSentCountSeasonsCompareStatistics.title',
    component: <Component>SuperAdminSentCountSeasonsCompareStatisticsComponent,
  },

  {
    name: PageNames.currentOrganSentStatusAggregateCompareStatistics,
    component: <Component>(
      CurrentOrganSentStatusAggregateCompareStatisticsComponent
    ),
  },
  {
    name: PageNames.currentOrganSentStatusSeasonCompareStatistics,
    title: 'pages.currentOrganSentStatusSeasonsCompareStatistics.title',
    component: <Component>(
      CurrentOrganSentStatusSeasonsCompareStatisticsComponent
    ),
  },

  {
    name: PageNames.superAdminSentStatusAggregateCompareStatistics,
    component: <Component>(
      SuperAdminSentStatusAggregateCompareStatisticsComponent
    ),
  },
  {
    name: PageNames.superAdminSentStatusSeasonCompareStatistics,
    title: 'pages.superAdminSentStatusSeasonsCompareStatistics.title',
    component: <Component>SuperAdminSentStatusSeasonsCompareStatisticsComponent,
  },

  {
    name: PageNames.currentUserOperatorAggregateCompareStatistics,
    component: <Component>(
      CurrentUserOperatorAggregateCompareStatisticsComponent
    ),
  },
  {
    name: PageNames.currentOrganOperatorAggregateCompareStatistics,
    component: <Component>(
      CurrentOrganOperatorAggregateCompareStatisticsComponent
    ),
  },
  {
    name: PageNames.superAdminOperatorAggregateCompareStatistics,
    component: <Component>SuperAdminOperatorAggregateCompareStatisticsComponent,
  },
  {
    name: PageNames.currentUserOperatorSeasonCompareStatistics,
    title: 'pages.currentUserOperatorSeasonsCompareStatistics.title',
    component: <Component>CurrentUserOperatorSeasonsCompareStatisticsComponent,
  },
  {
    name: PageNames.currentOrganOperatorSeasonCompareStatistics,
    title: 'pages.currentOrganOperatorSeasonsCompareStatistics.title',
    component: <Component>CurrentOrganOperatorSeasonsCompareStatisticsComponent,
  },
  {
    name: PageNames.superAdminOperatorSeasonCompareStatistics,
    title: 'pages.superAdminSentStatusSeasonsCompareStatistics.title',
    component: <Component>SuperAdminOperatorSeasonsCompareStatisticsComponent,
  },

  {
    name: PageNames.campaigns,
    component: <Component>CampaignsComponent,
  },
  {
    name: PageNames.packageSales,
    component: <Component>PackageSalesComponent,
  },
  {
    name: PageNames.createPackageOrganization,
    title: 'pages.packageOrganizations.title',
    component: <Component>PackageOrganizationsComponent,
  },
  {
    name: PageNames.packageOrganizations,
    title: 'pages.organizationPackages.title',
    component: <Component>OrganizationPackagesComponent,

    isMainMenu: false,
  },
  {
    name: PageNames.packageChildrenOrganizations,
    title: 'pages.childrenOrganizationsPackages.title',
    component: <Component>ChildrenOrganizationsPackagesComponent,
  },
  {
    name: PageNames.landingPage,
    component: <Component>LandingPageFormComponent,
  },
  {
    name: PageNames.landingPageList,
    component: <Component>LandingPageListComponent,
  },
  {
    name: PageNames.shortLinks,
    component: <Component>ShortLinksComponent,
  },
  {
    name: PageNames.descendantShortLinks,
    title: 'pages.shortLinks.descendantTitle',
    component: <Component>DescendantShortLinksComponent,
  },
  {
    name: PageNames.voiceMessagesList,
    title: 'pages.voiceMessages.title',
    component: <Component>VoiceMessagesComponent,
  },
  {
    name: PageNames.voiceMessagesGroupList,
    title: 'pages.voiceMessages.title',
    component: <Component>VoiceMessagesGroupComponent,
  },
  {
    name: PageNames.mediasList,
    title: 'pages.medias.title',
    component: <Component>MediasComponent,
  },
  {
    name: PageNames.discount,
    component: <Component>DiscountComponent,
  },
  {
    name: PageNames.privateNumbersPrice,
    component: <Component>PrivateNumbersPriceComponent,
  },
  {
    name: PageNames.privateNumbersPriceForUser,
    component: <Component>PrivateNumbersPriceForUserComponent,
  },
  {
    name: PageNames.privateNumberBuyRequests,
    component: <Component>PrivateNumberBuyRequestsComponent,

    isMainMenu: false,
  },
  {
    name: PageNames.childrenPrivateNumberBuyRequests,
    component: <Component>ChildrenPrivateNumberBuyRequestsComponent,
  },
  {
    name: PageNames.excelRequest,
    component: <Component>ExcelRequestComponent,
  },
  {
    name: PageNames.frontAudits,
    component: <Component>FrontAuditsComponent,
  },
  {
    name: PageNames.plansManagement,
    title: 'pages.plans.plansManagementTitle',
    component: <Component>PlansManagementComponent,
  },
  {
    name: PageNames.buyPlanModule,
    title: 'pages.plans.planListModuleForUser.title',
    component: <Component>GetPlansTypeModuleComponent,
  },
  {
    name: PageNames.buyPlanPackage,
    title: 'pages.plans.planListPackageForUser.title',
    component: <Component>GetPlansTypePackageComponent,

    isMainMenu: false,
  },
  {
    name: PageNames.zonePostalCodes,
    component: <Component>ZonePostalCodesComponent,
  },
  {
    name: PageNames.sendZonePostalCode,
    title: 'pages.sendBalkSms.titlePostalCode',
    component: <Component>SendZonePostalCodeSmsComponent,
  },
  {
    name: PageNames.sendSmartSmsToResidents,
    component: <Component>SendSmartSmsToResidentsComponent,
  },
  {
    name: PageNames.sendSmartSMS,
    component: <Component>SendSmartSmsCreateRequestComponent,
  },
  {
    name: PageNames.customPlace,
    component: <Component>CustomPlaceComponent,
  },
  {
    name: PageNames.smartSend,
    title: 'pages.smartSmsRequests.title',
    component: <Component>SendSmartSmsRequestListComponent,
  },
  {
    name: PageNames.resellerSmartSend,
    title: 'pages.resellerSmartSmsRequests.title',
    component: <Component>ResellerSmartSmsRequestComponent,
  },
  {
    name: PageNames.smartSmsRequestConfirmData,
    title: 'pages.confirmSmartSmsRequest.title',
    component: <Component>SendSmartSmsConfirmPage,
  },
  {
    name: PageNames.sendP2pSmartSms,
    component: <Component>SendP2pSmartSmsComponent,
  },
  {
    name: PageNames.smartSmsCampaign,
    title: 'pages.smartSmsCampaigns.title',
    component: <Component>SmartSmsCampaignsComponent,
  },
  {
    name: PageNames.smartSmsClub,
    title: 'pages.smartSmsClubs.title',
    component: <Component>SmartSmsClubsComponent,
  },
  {
    name: PageNames.smartDetail,
    component: <Component>SendSmartDetailsComponent,

    isMainMenu: false,
  },
  {
    name: PageNames.customerClubDevice,
    component: <Component>CustomerClubDevicesComponent,
  },
  {
    name: PageNames.calendarEvent,
    component: <Component>CalendarEventComponent,
  },
  {
    name: PageNames.numbersAggregator,
    component: <Component>NumbersAggregatorFormComponent,
  },
  {
    name: PageNames.numbersBlackList,
    title: 'pages.numbersBlackLists.title',
    component: <Component>NumbersBlackListsFormComponent,
  },
  {
    name: PageNames.queuesStatistics,
    component: <Component>GetQueuesStatisticsComponent,
  },
  {
    name: PageNames.currentOrganizationResellersStatistics,
    component: <Component>CurrentOrganizationResellersStatisticsComponent,
  },
  {
    name: PageNames.refundDeliveryStatus,
    component: <Component>RefundDeliveryStatusComponent,
  },
  {
    name: PageNames.documentsManagement,
    component: <Component>DocumentsManagementComponent,
  },
  {
    name: PageNames.sendSmartDetailsByDelivery,
    component: <Component>SendSmartDetailsByDeliveryComponent,

    isMainMenu: false,
  },
  {
    name: PageNames.domainConfiguration,
    title: 'pages.customerDomains.title',
    component: <Component>DomainConfigurationsFormComponent,

    isMainMenu: false,
  },
  {
    name: PageNames.fieldsManagement,
    component: <Component>FieldsManagementComponent,
  },
  {
    name: PageNames.formsManagement,
    component: <Component>FormsManagementComponent,
  },
  {
    name: PageNames.smartSmsNumberClasses,
    component: <Component>SmartSmsNumberClassesComponent,
  },
  {
    name: PageNames.checkNumberClassResponses,
    component: <Component>CheckNumberClassResponsesComponent,
  },
  {
    name: PageNames.onlineSurveyList,
    component: <Component>OnlineSurveyListComponent,
  },
  {
    name: PageNames.onlineSurveyResponses,
    component: <Component>OnlineSurveyResponsesComponent,
  },
  {
    name: PageNames.onlineSurveyStatistics,
    component: <Component>OnlineSurveyStatisticsComponent,
  },
  {
    name: PageNames.processTextResults,
    component: <Component>ProcessTextResultsComponent,
  },
];

export const PageListConfig = _PageListConfig.map((p) => ({
  ...p,
  title: p.title || `pages.${p.name}.title`,
}));
